export default __webpack_public_path__ + "static/media/SEH004-LUX-Lifestyle-page-2.f6c3f989.jpg";